import ProductPerStore from "@/models/loyaltyPanel/ProductPerStore";
import router from "@/routes"

export default {
    namespaced: true,

    state: () => ({
        stores: [],
        products: [],
        storesPagination: {},
        productsPagination: {},
        companyProducts: [],
        lang: "en"
    }),

    mutations: {
        setStores(state, payload) {
            state.stores = payload;
        },

        setProducts(state, payload) {
            state.products = payload;
        },

        setStoresPagination(state, payload) {
            state.storesPagination = payload;
        },

        setProductsPagination(state, payload) {
            state.productsPagination = payload;
        },

        setCompanyProducts(state, payload) {
            state.companyProducts = payload;
        },

        setLang(state, payload) {
            state.lang = payload;
        }
    },

    actions: {
        async getItems({ commit }, props) {
            try {
                commit("setLoading", true, { root: true });

                let storesRes = await ProductPerStore.getStores(
                    props.storesQuery
                );
                const storesData = storesRes.data.data;
                commit("setStoresPagination", storesData.pagination);
                let stores = storesData.stores;
                let productsRes = await ProductPerStore.getProducts(
                    props.productsQuery
                );
                const productsData = productsRes.data.data;
                commit("setProductsPagination", productsData.pagination);
                let companyProducts = productsData.company_products;
                commit("setLang", props.lang);

                let products = [];
                let headers = [];

                companyProducts.map(company_product => {
                    headers.push({
                        text: company_product.product_name[props.lang],
                        id: company_product.product_id,
                        updateAll: false
                    });
                });
                headers.unshift({});

                stores.map(store => {
                    let newProd = {
                        id: store.store_id,
                        name: store.name
                    };

                    store.products.map(product => {
                        let perantProduct = companyProducts.filter(
                            item => item.product_id == product
                        );
                        if (perantProduct && perantProduct[0]) {
                            newProd[
                                perantProduct[0].product_name[props.lang]
                            ] = true;
                        }
                    });

                    products.push(newProd);
                });
                if (!props.updateOnlyStores) {
                    commit("setStores", headers);
                }
                commit("setProducts", products);
                commit("setCompanyProducts", companyProducts);
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                console.error(ex);
            }
        },

        async updateCheckbox({ commit }, body) {
            try {
                commit("setLoading", true, { root: true });

                await ProductPerStore.updateCheckbox(body);

                commit("setDialog", false, { root: true });
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                console.error(ex.response.data);
            }
        },

        async addRemoveAll({ commit, dispatch, state }, body) {
            try {
                commit("setLoading", true, { root: true });

                await ProductPerStore.addRemoveAll(body);

                await dispatch("getItems", {
                    lang: state.lang || router.currentRoute.params.lang || 'en',
                    query: "?page=1",
                    updateOnlyStores: true
                });
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                console.error(ex.response.data);
            }
        }
    }
};
